module.exports = __webpack_public_path__ + "img/fk.8833fb78.svg";